/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import { useTranslation } from '../../../hooks';

type PropsFilterSelectObjectExams = {
  config: {
    component: any;
    name: any;
    status: any;
    bodyRequest: any;
    typeSearch: any;
  }
}

export function FilterSelectObjectExams({
  config
}: PropsFilterSelectObjectExams) {
  const { t } = useTranslation();
  return (
    React.createElement(config.component, {
      name: 'object',
      label: t(config.name),
      placeholder: `${t('Enter a')} ${t(config.name)}`,
      isModal: true,
      statusExam: config.status,
      bodyRequest: config.bodyRequest,
      type: config.typeSearch
    })
  );
}

export default FilterSelectObjectExams;
